import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const LinkTemplateComposer = lazy(() =>
  import("@scenes/MessageComposition/Email/LinkTemplates/LinkTemplateComposer").then((module) => ({
    default: module.LinkTemplateComposer,
  }))
);

export const engagementTemplatesAndMediaLinkTemplatesIdNRO: NavigationRoutingObject = {
  Component: LinkTemplateComposer,
  componentFeatureFlippers: ["link_templates_nro_component"],
  noKnockoutFallback: true,
  section: "templates",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("engagement-templates-and-media-link-templates-id-nro-heading", "Edit Link Template"),
  pageNameForTracking: () => "Edit Link Template",
  icon: "nav-system-email-link-templates",
  // View permission, not edit: this callback gates direct URL access, and LinkTemplateComposer
  // renders read-only for view-only developers (it hides the save/duplicate footer instead).
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    if (!featureOn("link_templating")) {
      return false;
    }
    return hasPermission("appGroupOrAnyTeamInAppGroup", { permission: "viewLinkTemplates" });
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
